import React from "react";
import { Select } from "@theorgchartdev/storybook";

import { BuildBranchStyleOptions } from "../../../../Navigation/ContextualToolbar/ToolbarOptions";
import { appstr } from "@coreapp/utils/appstr";
import { bsFlagMap } from "@coreapp/constants";

const BranchStyleSection = props => {
  const SetBranchStyle = target => {
    const rule = props.rule.Clone();
    //bsFlagMap handles translating the return value of the branch style picker into our format.
    rule.SetBranchStyleFlag(bsFlagMap[target.value]);
    props.setRule(rule);
  };

  let curBranchStyle = null;
  const curBSFlag = props.rule.GetBranchStyleFlag();

  //Branch style flags use a different data structure mapping than the actual integer values appleid to a chart.
  //We have to translate them here so they can be fed into a common interface.

  for (let flagItem in bsFlagMap) {
    if (bsFlagMap[flagItem] == curBSFlag) {
      curBranchStyle = flagItem;
      break;
    }
  }

  return (
    <Select
      optionSize={"small"}
      dataTestId="view-rule-editor-branch-style-select"
      id={"select-criteria-type-button-"}
      placeholder={appstr("selbranchstyle")}
      value={curBranchStyle}
      options={BuildBranchStyleOptions(SetBranchStyle, true, "view-rule-editor-branch-style-opt")}
    />
  );
};

export default BranchStyleSection;
